import { LogLevels, logLevels } from "./level.js";
import { status } from "./status.js";

/**
 *
 */
const levelMap = Object.fromEntries(
  /*                                  */
  logLevels.map((l, i) => [l, [console[l] || console.log, i]]),
) as Record<LogLevels, [typeof console.log, number]>;

/*                                                          */
export type Writer = (level: LogLevels, namespace: string, data: any[]) => void;

export const writeLog: Writer = (level, namespace, data): void => {
  const st = status();
  const [log, levelIndex] = levelMap[level];
  const [, activeLevelIndex] = levelMap[st.level];

  /*                               */
  if (levelIndex < activeLevelIndex || !st.pattern?.test(namespace)) {
    return;
  }

  log(`[ ${level.padStart(5)} ] %c${namespace}:`, "font-weight: bold;", ...data);
};

/*               */
export const noop: Writer = () => undefined;
